import { Field } from 'formik';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { PlayerPickerButton } from '@/components/composite/PlayerPickerButton';
import { JerseyPickerButton } from '@/components/composite/JerseyPickerButton';

interface OptionImageFieldsProps {
  index: number;
  optionImageEn: string;
  optionImageFr: string;
  selectedTeams?: string[];
  setFieldValue: (field: string, value: any) => void;
  isEditable: boolean;
}

export function OptionImageFields({
  index,
  optionImageEn,
  optionImageFr: _optionImageFr,
  selectedTeams = [],
  setFieldValue,
  isEditable,
}: OptionImageFieldsProps) {
  return (
    <div className="flex flex-col gap-2">
      <Label>Option Image URL</Label>
      <div className="relative w-full h-32 mb-2 border rounded-md overflow-hidden bg-gray-50">
        <img
          src={optionImageEn || '/no-jersey.png'}
          alt="Option preview"
          className="w-full h-full object-contain"
          onError={e => {
            e.currentTarget.src = '/no-jersey.png';
          }}
        />
      </div>
      <div className="flex gap-2">
        <Field
          as={Input}
          name={`options.${index}.option_image_en`}
          data-test-id={`question-option-${index}-option_image_en`}
          placeholder="https://example.com/image.jpg"
          disabled={!isEditable}
        />
        {isEditable && (
          <>
            <PlayerPickerButton
              selectedTeams={selectedTeams}
              onSelect={selection => {
                setFieldValue(`options.${index}.option_text_en`, selection.playerName);
                setFieldValue(`options.${index}.option_text_fr`, selection.playerName);
                setFieldValue(`options.${index}.option_image_en`, selection.jerseyUrl);
                setFieldValue(`options.${index}.option_image_fr`, selection.jerseyUrl);
              }}
              fieldLabel={`Option ${index + 1}`}
            />
            <JerseyPickerButton
              onSelect={url => {
                // Set both English and French to the same image URL
                setFieldValue(`options.${index}.option_image_en`, url);
                setFieldValue(`options.${index}.option_image_fr`, url);
              }}
              fieldLabel={`Option ${index + 1} Image`}
            />
          </>
        )}
      </div>
    </div>
  );
}
